import { useEffect } from 'react';
;
import { useSignalR } from '@/contexts/signalr-context';


// Generic, strongly-typed SignalR event subscription hook
export function useSignalREvent<T = unknown>(
  eventName: string,
  handler: (payload: T) => void
) {
  const { emitter } = useSignalR();

  useEffect(() => {
    if (!emitter) return;
    // Cast handler to (payload: unknown) => void for mitt compatibility
    emitter.on(eventName, handler as (payload: unknown) => void);
    return () => {
      emitter.off(eventName, handler as (payload: unknown) => void);
    };
  }, [eventName, handler, emitter]);
}
